import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import Dashboard from './components/Dashboard';
import CiclaInvoices from './components/cicla/CiclaInvoices';
import DocumentoDetalle from './components/cicla/DocumentoDetalle';
import PendientesSicla from './components/cicla/PendientesSicla';
import Clientes from './components/clientes/Clientes';
import PrivateRoute from './components/auth/PrivateRoute';
import Navbar from './components/layout/Navbar';
import ExcelImportWizard from './components/import/ExcelImportWizard';
import NotaCreditoWizard from './components/ndc/NotaCreditoWizard';
import ReporteDbaAuditTrailUsuarios from './components/reportes/ReporteDbaAuditTrailUsuarios';

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <AppContent />
        </div>
      </Router>
    </AuthProvider>
  );
};

const AppContent = () => {
  const { isAuthenticated } = useAuth();

  return (
    <>
      {isAuthenticated && <Navbar />}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/cicla-invoices" element={<PrivateRoute><CiclaInvoices /></PrivateRoute>} />
        <Route path="/documento-detalle/:iddocumento" element={<PrivateRoute><DocumentoDetalle /></PrivateRoute>} />
        <Route path="/clientes" element={<PrivateRoute><Clientes /></PrivateRoute>} />
        <Route path="/import-excel" element={<PrivateRoute><ExcelImportWizard /></PrivateRoute>} />
        <Route path="/nota-credito" element={<PrivateRoute><NotaCreditoWizard /></PrivateRoute>} />
        <Route path="/pendientes-sicla" element={<PrivateRoute><PendientesSicla /></PrivateRoute>} />
        <Route path="/reporte-dba-audit-trail-usuarios" element={<PrivateRoute><ReporteDbaAuditTrailUsuarios /></PrivateRoute>} />
        <Route path="/" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />} />
      </Routes>
    </>
  );
};

export default App;